import { minimalCustomerGroupSchema } from "@redotech/redo-model/customers/customer-group-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getSegmentsForCustomer = {
  name: "getSegmentsForCustomer" as const,
  input: z.object({ customerId: zExt.objectId() }),
  output: z.object({ segments: z.array(minimalCustomerGroupSchema) }),
};
